import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import SpacelistWidget from '@components/widget/SpacelistWidget';

const SpaceList = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-city mr-2" />
        Spacelist
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <SpacelistWidget />
        </Panel>
      </div>
    </div>
  </>
);

export default SpaceList;
